webpackJsonp([440],{

/***/ 1726:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(911),
  /* template */
  __webpack_require__(2082),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/donate-273.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] donate-273.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1f949b90", Component.options)
  } else {
    hotAPI.reload("data-v-1f949b90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2082:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("感谢赞助商")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("感谢捐赠用户")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("即将上线，捐赠时的附加信息也将显示在这里。")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("捐赠方式")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("欢迎通过下面渠道进行捐赠")])]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "best-companies"
  }, [_c('a', {
    attrs: {
      "href": "https://www.bmqb.com/a/jobs?tracking_code=opencollective",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ww1.sinaimg.cn/large/663d3650gy1fs3l6w13z2j206y02bdfp.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.upyun.com",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "52px"
    },
    attrs: {
      "src": "https://ww1.sinaimg.cn/large/663d3650gy1fs3l83hokej20b4040weg.jpg"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.sb/?utm_source=vux"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://wx1.sinaimg.cn/mw690/0060lm7Tly1ftmvim3r34j3056034wee.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.patreon.com/airyland"
    }
  }, [_vm._v("Patreon")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://opencollective.com/vux"
    }
  }, [_vm._v("Open Collective")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://paypal.me/airyland"
    }
  }, [_vm._v("PayPal")])]), _vm._v(" "), _c('li', [_vm._v("支付宝 airyland@qq.com")]), _vm._v(" "), _c('li', [_vm._v("企业赞助捐赠请联系 i@mao.li")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f949b90", module.exports)
  }
}

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1726);

/***/ }),

/***/ 911:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "捐赠支持 VUX | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 440.a3a993f5.js